import { Injectable } from '@angular/core';
import { UserService } from 'app/services/user.service';
import { Observable, of, throwError } from 'rxjs';
import { Logger } from 'app/utilities/logger';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';


// This class is a Signleton, use it to cache general local variables  

@Injectable({
  providedIn: 'root'
})
export class SessionStorage {

  
    roles:string[] = []
    username:string = ''
    userId: number | null = null

    url: string | null = null

    public auth$: Observable<{roles: string[], username: string, picture: string, id?: number}>


    constructor(
        private userService : UserService,
        private logger: Logger,
        private router: Router
    ) {
        this.url = null
        this.auth$ = this.userService.getRoles()
        this.auth$.subscribe({
            next: then => {
                if (!(then.roles.indexOf("call_manager") >= 0 || then.roles.indexOf("project_board") >= 0 || then.roles.indexOf("epe") >= 0 || then.roles.indexOf("project_v2") >= 0 || then.roles.indexOf("epe_v2") >= 0 || then.roles.indexOf("project") >= 0 || then.roles.indexOf("hsb2_epe") >= 0 || then.roles.indexOf("hsb2_project") >= 0 )) {
                  //window.location.href = environment.apiHost+"/user/login";
                }
                this.roles = then.roles;
                this.username = then.username;
                this.userId = then.id ?? null;
                if (this.url) {
                  this.router.navigate([this.url]);
                }
                this.logger.info(this.roles);
              },
            error: err => {
                this.roles = ['not_authenticated', 'guest']
                this.username = 'guest'
                console.log(this.roles, this.username)
                this.auth$ = of({roles: this.roles, username: this.username, picture: ''});
            }
        })
     }

    canNavigate(url: string): boolean{

        if(this.roles.length == 0)
            this.url = url

        if(url === '/associations')
            return this.isCallManager() || this.isProjectBoard()
        else if(url === '/form')
            return this.isEpe() || this.isProject()
        else if(url === '/assigned-services')
            return this.isEpe() || this.isProject()
        else if(url === '/advice-form')
            return this.isEpe() || this.isProject() || this.isGuest()
        else if(url === '/my-applications')
            return this.isEpe() || this.isProject()
        else if(url.startsWith('/sot-submission/'))
            return this.isEpe() || this.isProject()
        else if(url === '/application-form/epe')
            return this.isEpe()
        else if(url.startsWith('/application-form/service/'))
            return this.isProject()
        else
            return this.isCallManager() || this.isProjectBoard()
    }

    setUsername(username: string):void {
        this.username = username
    }

    getUsername(): string {
        return this.username
    }

    isAuthenticated(): boolean{
        return this.roles.indexOf('authenticated') >= 0
    }

    isAuthorized(acceptedRoles: string[]): boolean {
        return this.roles.some( x => acceptedRoles.indexOf(x) >= 0)
    }

    setRoles(roles: string[]): void {
        this.roles = roles
    }

    isAdmin(): boolean{
        return this.roles.indexOf('administrator') >= 0
    }

    isProjectBoard(): boolean{
        return this.roles.indexOf('project_board') >= 0
    }

    isCallManager(): boolean{
        return this.roles.indexOf('call_manager') >= 0
    }

    isEpe(): boolean{
        return this.roles.indexOf('epe') >= 0 || this.roles.indexOf('epe_v2') >= 0 || this.roles.indexOf('hsb2_epe') >= 0
    }

    isProject(): boolean{
        return this.roles.indexOf('project') >= 0 || this.roles.indexOf('project_v2') >= 0 || this.roles.indexOf('hsb2_project') >= 0
    }

    isGuest(): boolean{
        return this.roles.indexOf('guest') >= 0
    }
}